export const EMPTY_PRESET_FEATURES: string[] = [];
